import { Button, Text, Badge, Box } from '@chakra-ui/react';
import {
  DialogRoot,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogCloseTrigger,
  DialogTitle,
} from '@/components/ui/dialog';
import { useWidgetPortalProps } from '@/features/widget/hooks/widget-modal-hooks';

interface AITakeoverConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function AITakeoverConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
}: AITakeoverConfirmationModalProps) {
  const portalProps = useWidgetPortalProps();

  return (
    <DialogRoot
      open={isOpen}
      onOpenChange={onClose}
      closeOnInteractOutside={false}
      {...portalProps}
    >
      <DialogContent>
        <DialogHeader position="relative">
          <Badge
            colorPalette="orange"
            variant="solid"
            borderRadius="full"
            px={2}
            py={0.5}
            fontSize="xs"
            position="absolute"
            top="-8px"
            left="-8px"
            transform="rotate(-12deg)"
            zIndex={10}
            boxShadow="md"
          >
            Beta
          </Badge>
          <DialogTitle>Hand Over to AI Agent</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Box
            bg="orange.50"
            border="1px"
            borderColor="orange.200"
            borderRadius="md"
            p={3}
            mb={4}
          >
            <Text fontSize="sm" color="orange.800" fontWeight="medium">
              The AI Agent functionality is in beta and can make mistakes.
            </Text>
          </Box>
          <Text>
            Are you sure you want to hand this conversation back to the AI
            agent? You will no longer be able to send messages until you take
            over again.
          </Text>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>

          <Button colorPalette="green" onClick={onConfirm}>
            Yes, Hand Over to AI
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
}
